export default {
	title: 'Inspection Organization',
	actions: {
		add: 'Add',
		edit: 'Edit',
		delete: 'Delete',
		batchDelete: 'Batch Delete'
	},
	messages: {
		deleteConfirm: 'Are you sure you want to delete the selected {count} records?',
		deleteSuccess: 'Operation successful',
		selectDeleteWarning: 'Please select the records to delete',
		operateSuccess: 'Operation successful',
		requiredFieldCannotBeEmpty: 'Required field cannot be empty'
	},
	table: {
		id: 'ID',
		name: 'Name',
		location: 'Location',
		icon: 'Icon'
	},
	buttons: {
		expandAll: 'Expand All',
		collapseAll: 'Collapse All',
		add: 'Add',
		edit: 'Edit',
		delete: 'Delete'
	},
	dialog: {
		add: 'Add',
		edit: 'Edit',
		cancel: 'Cancel',
		confirm: 'Confirm'
	},
	widgetForm: {
		superiorDepartment: 'Superior Department',
		name: 'Name',
		location: 'Location',
		icon: 'Icon',
		leader: 'Leader',
		sort: 'Sort',
		logoPicture: 'Logo Picture',
		aiAssistantEnabled: 'AI Assistant Enabled',
		gridLayout: 'Grid Layout',
		sensorStatusChangeNotify: 'Sensor Status Change Notification',
		requiredFieldCannotBeEmpty: 'Required field cannot be empty',
		placeholder: {
			superiorDepartment: 'Please select superior department',
			name: 'Please enter name',
			location: 'Please enter location',
			icon: 'Please select icon',
			leader: 'Please select leader',
			sort: 'Please enter sort',
			aiAssistantEnabled: 'Please select whether to enable',
			sensorStatusChangeNotify: 'Sensor Status Change Notification'
		},
		options: {
			aiAssistantStatus: {
				closed: 'Closed',
				enabled: 'Enabled'
			},
			notifyStatus: {
				offline: 'Offline Notification',
				abnormal: 'Abnormal Notification',
				all: 'Notify All',
				none: 'Do Not Notify'
			}
		}
	}
}
